document.addEventListener("DOMContentLoaded", async () => {
  const box = document.getElementById("recommended-by-meta");
  if (!box) return;

  console.log("SCRIPT OK");

  const author = box.dataset.author;
  if (!author) {
    console.log("NU exista author");
    return;
  }

  const res = await fetch(`/search?q=${encodeURIComponent(author)}&type=product&view=recommendations`);
  const html = await res.text();

  console.log("HTML primit:", html);

  box.innerHTML = `
    <div class="page-width">
      <h2>Produse înrudite:</h2>
        <ul class="grid product-grid grid--2-col-tablet-down grid--4-col-desktop" role="list">
        ${html}
      </ul>
    </div>
  `;
});
